/**
 * @file 包含滑点受损逻辑的行
 */
import { useFm } from '@web3/base-hooks';
import { Row } from '../normal';
import BigNumber from 'bignumber.js';
import cls from 'classnames';

import styles from './index.module.scss';

interface Props {
  className?: string;
  show: boolean;
  slippage: string;
  isWarn: boolean;
  showArrow?: boolean;
  onClickArrow?: () => void;
}

export const SlippageLostRow = (props: Props) => {
  const { className, slippage, show, isWarn, showArrow, onClickArrow } = props;
  const fm = useFm();
  return (
    <Row
      className={cls(styles.container, className)}
      show={show}
      label={fm('slippage')}
      value={
        <>
          {isWarn && (
            <div>
              {fm('actualNumLessThanEstimated', {
                num: (
                  <span
                    className={styles.warn}
                  >{`${BigNumber(BigNumber(slippage).toFixed(4)).toFixed()}%`}</span>
                ),
              })}
            </div>
          )}
          {!isWarn && `${BigNumber(BigNumber(slippage).toFixed(4)).toFixed()}%`}
        </>
      }
      showArrow={showArrow}
      onClickArrow={onClickArrow}
    />
  );
};
